
function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/partyA/user/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'user')
    }
}

let routes = [
    {
        path: '',
        redirect: '/partyALogin',
        meta: {
            title: '登录'
        }
    },
    {
        name: 'partyALogin',
        path: '/partyALogin',
        meta: {
            title: '登录'
        }
    },
    {
        name: 'partyAMy',
        path: '/partyAMy',
        meta: {
            title: '个人中心'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/partyA/user.js